import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { NakedButton, Text } from '@frontend/design-system';

type Props = {
  handleAddSegment: () => void;
  trackingIdPrefix: string;
};

export const AddSegmentButton = ({ handleAddSegment, trackingIdPrefix, ...rest }: Props) => {
  const { t } = useTranslation('bulk-messaging');

  return (
    <NakedButton
      css={{ display: 'flex', marginTop: theme.spacing(1) }}
      onClick={handleAddSegment}
      trackingId={`${trackingIdPrefix}-create-segment-btn`}
      {...rest}
    >
      <Icon name='plus' color='primary' css={{ marginRight: theme.spacing(0.5) }} />
      <Text color='primary'>{t('Create Segment')}</Text>
    </NakedButton>
  );
};
